import { WebinarCardProps } from './types';

export const WebinarCard = ({ children }: WebinarCardProps) => <div className="text-sm">{children}</div>;
